import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { Botao, IconeModalSucesso, ModalBase } from 'src/componentes'
import { RotasApp } from 'src/rotas'

import { Corpo, Texto, Titulo } from './styles'

export interface ModalSucessoSolicitacaoRescisaoRef {
  abrir: (numeroProtocolo: string) => void
  fechar: () => void
}

interface ModalSucessoSolicitacaoRescisaoProps {
  backdrop?: boolean
}

const ModalSucessoSolicitacaoRescisaoComponente: React.ForwardRefRenderFunction<
  ModalSucessoSolicitacaoRescisaoRef,
  ModalSucessoSolicitacaoRescisaoProps
> = ({ backdrop }, ref) => {
  const history = useHistory()
  const [aberta, definirAberta] = useState(false)
  const [numeroProtocolo, definirNumeroProtocolo] = useState<string>(null)

  const fechar = () => definirAberta(false)

  const abrir = (numero: string) => {
    definirNumeroProtocolo(numero)
    definirAberta(true)
  }

  useImperativeHandle(ref, () => ({ abrir, fechar }))

  const voltarAoInicio = () => {
    fechar()
    history.push(RotasApp.Home)
  }

  return (
    <ModalBase id="modal-sucesso-solicitacao-rescisao" aberta={aberta} backdrop={backdrop}>
      <Corpo>
        {IconeModalSucesso}
        <Titulo>Protocolo recebido!</Titulo>
        <Texto>
          Seu protocolo de rescisão de número <strong>{numeroProtocolo}</strong>{' '}
          foi aberto e em breve você receberá o contato de nosso time para lhe
          dar a atenção necessária e ajudar nesta situação.
        </Texto>
        <Botao texto="Voltar ao início" type="button" onClick={voltarAoInicio} />
      </Corpo>
    </ModalBase>
  )
}

export const ModalSucessoSolicitacaoRescisao = forwardRef(
  ModalSucessoSolicitacaoRescisaoComponente
)
